import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const MobileHeaderContainer = styled.div`
  position: fixed;
  width: 100%;
  z-index: ${Styles.zIndex.overlay};
  top: 0;
  ${Styles.desktop`
    display: none;
  `}
`;

export type HeaderProps = {
  nativeStatusBarExist: boolean;
};
export const Header = styled.div<HeaderProps>`
  align-items: center;
  background: ${p => p.theme.token('top-nav-bar-background-color')};
  color: ${p => p.theme.token('text-reversed')};
  display: flex;
  height: ${Styles.layout.navHeight.mobile};
  justify-content: space-between;
  padding: 1rem;
  ${Styles.mobileFullscreen`
    padding: 2rem 1rem 1.5rem;
    padding-top: ${(p: HeaderProps) =>
      p.nativeStatusBarExist
        ? 'calc(env(safe-area-inset-top) + 1.3rem)'
        : 'calc(env(safe-area-inset-top) + 2rem)'};
  `}
  text-align: center;
  width: 100%;
`;

export const LinkNoDecoration = styled(Link)`
  ::before {
    color: transparent;
  }
  &:active,
  &:hover,
  &:link,
  &:visited {
    color: inherit;
  }
`;
